import { Footer } from "./-components/footer"
import { Header } from "./-components/header"
import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/(site)")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-16">
        <Outlet />
      </main>

      <Footer />
    </div>
  )
}
